import { get } from 'lodash';

import { DeclarationCustomsFlowType, DeclarationStatus } from '../enums';

export const getTotal = (b: any, status: DeclarationStatus, flow: DeclarationCustomsFlowType = DeclarationCustomsFlowType.POST): number => {
  const flowStats = get(b?.statistics?.in, flow, []);
  return (flowStats.find((statusStatistics) => statusStatistics.status === status)?.total as number) ?? 0;
};
